module.exports = __webpack_public_path__ + "static/irrigation-video-ab53e025378dcbaca0ab3c37b98675ff.mp4";